import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { CalendarClock, ArrowRight } from "lucide-react";
import { formatDateTime } from "@/lib/helpers";

// Parent Dashboard -> "Upcoming Lessons & Classes" card. Extracted from
// ParentDashboard.js (props-driven, no behavior change).
export const UpcomingLessonsCard = ({ upcoming, onRequestReschedule }) => (
  <section className="lg:col-span-2 rounded-[var(--radius)] border bg-card">
    <div className="flex items-center justify-between p-4 sm:p-5 border-b">
      <h2 className="text-lg font-semibold font-heading flex items-center gap-2">
        <CalendarClock className="h-5 w-5 text-[hsl(var(--role-accent))]" /> Upcoming Lessons & Classes
      </h2>
      <Link to="/schedule" className="text-sm text-[hsl(var(--role-accent))] font-medium flex items-center gap-1">
        View all <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
    <div className="divide-y">
      {upcoming.length === 0 && (
        <p className="p-6 text-sm text-muted-foreground text-center">No upcoming lessons scheduled.</p>
      )}
      {upcoming.map((appt) => (
        <div key={appt.id} className="flex items-center justify-between gap-3 p-4 sm:p-5" data-testid="parent-upcoming-lesson-row">
          <div className="min-w-0">
            <p className="font-medium text-sm truncate">{appt.student_name} - {appt.type === "lesson" ? "Driving Lesson" : "Classroom"}</p>
            <p className="text-xs text-muted-foreground truncate">
              {formatDateTime(appt.start_time)} &middot; Instructor: {appt.instructor_name || "-"}
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <StatusBadge status={appt.status} />
            {appt.type === "lesson" && (
              <Button size="sm" variant="outline" onClick={() => onRequestReschedule(appt)} data-testid="parent-request-reschedule-button">
                Reschedule
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  </section>
);
